import React from 'react'

// Style sheet
import 'bootstrap/dist/css/bootstrap.min.css';
import '../scss/southChinaSeaForcast.scss';

// Bootstrap Components
import Container from 'react-bootstrap/Container';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';

// Page componets
import OceanMap from '../../mapcomponents/ts/oceanMap';

export default function SouthChinaSeaForcast() {
  return (
    <Container>
      <div id="southChinaSeaForcastBox">
        <div id="southChinaSeaForcastBox_Title">華南海域天氣報告(天文台)</div>
        <div id="southChinaSeaForcastBox_Content">
          <OceanMap />
        </div>
      </div>
    </Container>
    
  )
}
